import React, { useState } from 'react'
import {
  PanelCollapsible,
  Grid,
  GridCell,
  SpacingVertical,
  Divider
} from 'mailup-web-components'
import { useIntl } from 'react-intl'
import ButtonColors from './ButtonColors'
import ButtonTypography from './ButtonTypography'
import ButtonBorder from './ButtonBorder'
import ButtonPadding from './ButtonPadding'
import {
  DESKTOP,
  MOBILE,
  Preview,
  PREVIEW_BUTTON
} from 'Pages/EmailContentDefaults/shared/Preview'
import ButtonMobile from './ButtonMobile'
import ButtonBlock from './ButtonBlock'

const Button = () => {
  const [collapsed, setSollapsed] = useState(true)

  const intl = useIntl()
  return (
    <PanelCollapsible
      onChange={() => setSollapsed(!collapsed)}
      collapsed={collapsed}
      title={intl.formatMessage({ id: 'Load.ContentDefaults.Buttons' })}
      titleVariant='L'
    >
      <Grid>
        <GridCell span={8}>
          <ButtonColors />
          <ButtonTypography />
          <ButtonBorder />
          <ButtonPadding />
          <ButtonBlock />
        </GridCell>
        <GridCell span={4}>
          <Preview type={DESKTOP} preview={PREVIEW_BUTTON} />
        </GridCell>
      </Grid>
      <Divider />
      <SpacingVertical />
      <Grid>
        <GridCell span={8}>
          <ButtonMobile />
        </GridCell>
        <GridCell span={4}>
          <Preview type={MOBILE} preview={PREVIEW_BUTTON} />
        </GridCell>
      </Grid>
    </PanelCollapsible>
  )
}

export default Button
